import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import CollectionsPreview from '../components/CollectionsPreview';
import AboutPreview from '../components/AboutPreview';
import ReviewsSection from '../components/ReviewsSection';
import WhatsAppCTA from '../components/WhatsAppCTA';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#fffef2]">
      <Header />
      <main>
        <HeroSection />
        <CollectionsPreview />
        <AboutPreview />
        <ReviewsSection />
        <WhatsAppCTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
